(function(){
'use strict';

/* === PRODUCT PAGE: Trust Badges Below ATC === */
function addTrustBadges(){
  var form = document.querySelector('.product-form');
  if(!form || document.querySelector('.df-trust-row')) return;
  var row = document.createElement('div');
  row.className = 'df-trust-row';
  row.innerHTML = '<div class="df-trust-row__item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>Secure Checkout</div>'
    + '<div class="df-trust-row__item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="1" y="3" width="22" height="18" rx="2"/><path d="M1 10h22"/></svg>Discreet Billing</div>'
    + '<div class="df-trust-row__item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a4 4 0 00-8 0v2"/></svg>Plain Packaging</div>'
    + '<div class="df-trust-row__item"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"/><path d="M9 22V12h6v10"/></svg>30-Day Returns</div>';
  form.parentNode.insertBefore(row, form.nextSibling);
}

/* === PRODUCT PAGE: Save Percentage === */
function addSaveBadge(){
  var prices = document.querySelectorAll('.price--on-sale');
  prices.forEach(function(p){
    if(p.querySelector('.df-save-pct')) return;
    var reg = p.querySelector('.price-item--regular');
    var sale = p.querySelector('.price-item--sale');
    if(!reg || !sale) return;
    var rp = parseFloat(reg.textContent.replace(/[^0-9.]/g,''));
    var sp = parseFloat(sale.textContent.replace(/[^0-9.]/g,''));
    if(rp > 0 && sp > 0 && rp > sp){
      var pct = Math.round((1 - sp/rp) * 100);
      var badge = document.createElement('span');
      badge.className = 'df-save-pct';
      badge.textContent = 'Save ' + pct + '%';
      sale.parentNode.insertBefore(badge, sale.nextSibling);
    }
  });
}

/* === CART: Free Shipping Progress Bar === */
function addShippingBar(){
  var cartDrawer = document.querySelector('cart-drawer .cart-drawer__inner, .drawer__inner');
  if(!cartDrawer || document.querySelector('.df-shipping-bar')) return;
  var totalEl = cartDrawer.querySelector('.totals__total-value, .cart__total .price');
  if(!totalEl) return;
  var total = parseFloat(totalEl.textContent.replace(/[^0-9.]/g,'')) || 0;
  var threshold = 99;
  var pct = Math.min(100, Math.round(total / threshold * 100));
  var remaining = Math.max(0, threshold - total).toFixed(2);
  
  var bar = document.createElement('div');
  bar.className = 'df-shipping-bar';
  if(pct >= 100){
    bar.innerHTML = '<div class="df-shipping-bar__text">\u2705 You qualify for <strong>FREE discreet shipping!</strong></div><div class="df-shipping-bar__track"><div class="df-shipping-bar__fill" style="width:100%"></div></div>';
  } else {
    bar.innerHTML = '<div class="df-shipping-bar__text">Add <strong>$' + remaining + '</strong> more for <strong>FREE discreet shipping</strong></div><div class="df-shipping-bar__track"><div class="df-shipping-bar__fill" style="width:' + pct + '%"></div></div>';
  }
  cartDrawer.insertBefore(bar, cartDrawer.firstChild);
}

/* === Observe cart drawer open === */
var cartObs = new MutationObserver(function(muts){
  muts.forEach(function(m){
    if(m.target.classList && m.target.classList.contains('active')){
      setTimeout(addShippingBar, 300);
    }
  });
});
var cd = document.querySelector('cart-drawer');
if(cd) cartObs.observe(cd, {attributes:true, attributeFilter:['class','open']});

/* === EXIT INTENT POPUP (desktop only) === */
function initExitPopup(){
  if(window.innerWidth < 750) return;
  if(localStorage.getItem('df_popup_shown')) return;
  
  var overlay = document.createElement('div');
  overlay.className = 'df-popup-overlay';
  overlay.innerHTML = '<div class="df-popup"><button class="df-popup__close" aria-label="Close">&times;</button><div class="df-popup__title">Wait — 10% Off Your First Order</div><div class="df-popup__text">Join the Inner Circle for exclusive drops, guides, and your welcome discount.</div><div class="df-popup__form"><input type="email" placeholder="Enter your email" aria-label="Email"><button type="button">Get 10% Off</button></div></div>';
  document.body.appendChild(overlay);
  
  var shown = false;
  document.addEventListener('mouseout', function(e){
    if(shown) return;
    if(e.clientY < 10 && e.relatedTarget === null){
      shown = true;
      overlay.classList.add('active');
      localStorage.setItem('df_popup_shown', '1');
    }
  });
  
  overlay.querySelector('.df-popup__close').addEventListener('click', function(){
    overlay.classList.remove('active');
  });
  overlay.addEventListener('click', function(e){
    if(e.target === overlay) overlay.classList.remove('active');
  });
  
  overlay.querySelector('.df-popup__form button').addEventListener('click', function(){
    var email = overlay.querySelector('input[type=email]').value;
    if(email && email.indexOf('@') > 0){
      this.textContent = 'Thank You!';
      this.disabled = true;
      setTimeout(function(){ overlay.classList.remove('active'); }, 2000);
    }
  });
}

/* === BREADCRUMBS === */
function addBreadcrumbs(){
  if(document.querySelector('.df-breadcrumb')) return;
  var main = document.querySelector('main, #MainContent');
  if(!main) return;
  
  var path = window.location.pathname;
  var crumb = document.createElement('div');
  crumb.className = 'df-breadcrumb page-width';
  var items = ['<a href="/">Home</a>'];
  
  if(path.indexOf('/products/') === 0){
    var colLink = document.querySelector('.product__text a[href*="/collections/"]');
    if(colLink){
      items.push('<a href="' + colLink.href + '">' + colLink.textContent.trim() + '</a>');
    }
    var title = document.querySelector('.product__title, h1');
    if(title) items.push('<span>' + title.textContent.trim() + '</span>');
  } else if(path.indexOf('/collections/') === 0){
    var h1 = document.querySelector('.collection-hero__title, h1');
    if(h1) items.push('<span>' + h1.textContent.trim() + '</span>');
  }
  
  if(items.length > 1){
    crumb.innerHTML = items.join('<span class="df-breadcrumb__sep">/</span>');
    main.insertBefore(crumb, main.firstChild);
  }
}

/* === INIT === */
function init(){
  addTrustBadges();
  addSaveBadge();
  addBreadcrumbs();
  setTimeout(initExitPopup, 5000);
}

if(document.readyState === 'loading'){
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
})();

/* =====================================================
   RECENTLY VIEWED — track + render (DF Section)
   ===================================================== */
(function initRecentlyViewed() {
  const RV_KEY = 'df_rv';
  const MAX_STORE = 8;
  const MAX_SHOW = 4;
  var rvEl = document.getElementById('dfRecentlyViewed');
  if (!rvEl) return;
  var currentHandle = rvEl.dataset.current || '';

  function getRV() {
    try { return JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch(e) { return []; }
  }

  // Track current product — pull data from existing page JSON-LD or meta
  if (currentHandle) {
    try {
      var title = document.querySelector('h1.product__title, h1') ? document.querySelector('h1.product__title, h1').textContent.trim() : document.title.split('|')[0].trim();
      var imgEl = document.querySelector('.product__media img, .product-media img');
      var imgSrc = imgEl ? (imgEl.dataset.src || imgEl.src || '') : '';
      // Get price from Shopify money spans
      var priceEl = document.querySelector('.price__sale .money, .price .money, .product__price .money');
      var priceText = priceEl ? priceEl.textContent.trim() : '';
      var items = getRV().filter(function(i) { return i.handle !== currentHandle; });
      items.unshift({ handle: currentHandle, title: title, url: window.location.pathname, image: imgSrc, price: priceText });
      localStorage.setItem(RV_KEY, JSON.stringify(items.slice(0, MAX_STORE)));
    } catch(e) {}
  }

  // Render up to MAX_SHOW items excluding current
  var items = getRV().filter(function(i) { return i.handle !== currentHandle; }).slice(0, MAX_SHOW);
  if (items.length === 0) { rvEl.style.display = 'none'; return; }

  var h2 = rvEl.querySelector('h2');
  if (h2) h2.textContent = 'Recently Viewed';
  var grid = rvEl.querySelector('.df-rv-grid');
  if (!grid) return;

  grid.innerHTML = items.map(function(item) {
    var imgHtml = item.image
      ? '<div class="df-rv-img"><img src="' + item.image + '" alt="' + item.title.replace(/"/g,'&quot;') + '" loading="lazy" width="300" height="300"></div>'
      : '<div class="df-rv-img df-rv-img--placeholder"></div>';
    var priceHtml = item.price ? '<div class="df-rv-price">' + item.price + '</div>' : '';
    return '<a href="' + item.url + '" class="df-rv-card">' + imgHtml + '<div class="df-rv-info"><div class="df-rv-title">' + item.title + '</div>' + priceHtml + '</div></a>';
  }).join('');
})();

/* =====================================================
   SOCIAL PROOF — "X people viewing" live badge
   ===================================================== */
(function initSocialProof() {
  // Only on product pages with an add-to-cart form
  var form = document.querySelector('form[action*="/cart/add"]');
  if (!form) return;
  // Don't double-inject
  if (document.querySelector('.df-viewing-badge')) return;

  // Seeded pseudo-random from product handle for session consistency
  var handle = document.location.pathname.split('/products/').pop() || 'product';
  var seed = 0;
  for (var i = 0; i < handle.length; i++) seed += handle.charCodeAt(i);
  function seeded(n) { seed = (seed * 1664525 + 1013904223) & 0x7fffffff; return seed % n; }

  var base = 8 + seeded(30); // 8-37
  var current = base;

  var badge = document.createElement('div');
  badge.className = 'df-viewing-badge';
  badge.innerHTML = '<span class="df-vb-dot"></span><span class="df-vb-text"><strong class="df-vb-num">' + current + '</strong> people viewing this right now</span>';
  form.parentElement.insertBefore(badge, form);

  function fluctuate() {
    var delta = seeded(3) - 1; // -1, 0, +1
    current = Math.max(4, Math.min(base + 10, current + delta));
    var num = badge.querySelector('.df-vb-num');
    if (num) num.textContent = current;
    setTimeout(fluctuate, 9000 + seeded(8000));
  }
  setTimeout(fluctuate, 12000 + seeded(6000));
})();
